import { useTranslation } from 'react-i18next';
import { StopPlaceState } from '../../../../../../types/stop-registry';
import { mapStopPlaceStateToUiName } from '../../../../../../utils/i18n';
import { EnumDropdown } from '../../../../../common/Dropdowns';
import { InputField } from '../../../../../common/Inputs';
import { Column, FormRow } from '../../../../../common/LayoutComponents';
import { StopBasicDetailsFormState } from './schema';

const testIds = {
  label: 'StopBasicDetailsForm::label',
  privateCode: 'StopBasicDetailsForm::privateCode',
  locationFin: 'StopBasicDetailsForm::locationFin',
  locationSwe: 'StopBasicDetailsForm::locationSwe',
  stopPlaceState: 'StopBasicDetailsForm::stopPlaceState',
};

export const StopLabelAndLocationFormRow = () => {
  const { t } = useTranslation();

  return (
    <>
      <h3>{t(($) => $.stopDetails.basicDetails.stopInformation)}</h3>
      <FormRow mdColumns={5}>
        <Column>
          <InputField<StopBasicDetailsFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="label"
            // TODO: This is disabled until we add a confirmation dialog, because changing
            // the label of a stop will remove it from routes.
            disabled
            testId={testIds.label}
          />
        </Column>
        <Column>
          <InputField<StopBasicDetailsFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="privateCode"
            testId={testIds.privateCode}
          />
        </Column>
        <Column>
          <InputField<StopBasicDetailsFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="locationFin"
            testId={testIds.locationFin}
          />
        </Column>
        <Column>
          <InputField<StopBasicDetailsFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="locationSwe"
            testId={testIds.locationSwe}
          />
        </Column>
        <Column>
          <InputField<StopBasicDetailsFormState>
            translationPrefix="stopDetails.basicDetails"
            fieldPath="stopState"
            testId={testIds.stopPlaceState}

            inputElementRenderer={(props) => (
              <EnumDropdown<StopPlaceState>
                enumType={StopPlaceState}
                placeholder={t(($) => $.stopDetails.basicDetails.stopState)}
                uiNameMapper={(value) => mapStopPlaceStateToUiName(t, value)}
                {...props}
              />
            )}
          />
        </Column>
      </FormRow>
    </>
  );
};
